import { render } from "./uiToggle.vue?vue&type=template&id=3fa17f09&ts=true"
import script from "./uiToggle.vue?vue&type=script&lang=ts"
export * from "./uiToggle.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\AttiTec\\DogToDo\\dev\\todo-list-vuejs-pwa-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__